import Badge from "@/tpo/Badge";

export default function InactiveBadge({ text = "inactive", mr = 0 }) {
  return (
    <Badge bg="white" color="dark" size="xs" withBorder mr={mr}>
      {text}
    </Badge>
  );
}
